import { Component } from 'react';
import { connect } from 'react-redux';
import { translate, translateToHTML } from '../../../../../react/features/base/i18n/functions';
import { QUALITY_CONTROL_LABELS } from '../../constant';
class CustomTextLabel extends Component {
    render() {
        const { t, qualityLastN, videoResolution, videoConfigResolution } = this.props;
        return (translateToHTML(t, 'qualityControl.tooltipTitleWeb', {
            numberOfUsers: qualityLastN !== null ? qualityLastN.toString() : QUALITY_CONTROL_LABELS.LAST_N,
            videoResolution: videoResolution !== null ? videoResolution.toString() : videoConfigResolution
        }));
    }
}
export function _mapStateToProps(state) {
    const { qualityLastN, qualityVideoResolution } = state['wildix/qualityControl'];
    const { constraints } = state['features/base/config'];
    return {
        videoConfigResolution: constraints?.video?.height?.max ?? '720',
        qualityLastN,
        videoResolution: qualityVideoResolution
    };
}
export default translate(connect(_mapStateToProps)(CustomTextLabel));
